/**
 * Input Schema of ResponsavelWebhook
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelWebhook} from '@/model/resource/ResponsavelWebhook'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import {TypeWebhookCollection} from '@/model/collection/TypeWebhookCollection'

/* TODO: review generated schema */
export class InputResponsavelWebhookSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()
  collectionTypeWebhook = new TypeWebhookCollection().noPagination()

  readonly name = 'InputResponsavelWebhook'

  readonly fieldSet: FieldSet<ResponsavelWebhook> = {
    responsavel: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    typeWebhook: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionTypeWebhook.all(),
      },
    }),
    url: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'text',
        maxlength: 255,
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required|url',
      },
    }),
  }
}
